const Spinner = ({ isActive }) => {
  return (
    <div
      className={`w-6 h-6 animate-spin rounded-[50%] border-t-[#ee4724] border-4 border-solid border-gray-50]
        ${!isActive ? 'invisible' : ''}`}
    ></div>
  )
}

export default Spinner
